/* eslint-disable import/prefer-default-export */

export const VariationIds = {
  Cpc_AB_Test: "201",
  Search_AB_Test: "202", // search page not currently sending VariationId
};
